export default "__VITE_ASSET__BVKzw0SW__"